export const useDispatchGetNetworkAndPublishersAccountsOptions = () => {
  // In dsp ui this hook triggers only redux dispatch call on component mount.
  // To avoid increasing complexity of libs/components/package/src/lib/components/PackageForm/sections/OnBehalfOfForm.tsx
  // with conditional hooks this hook is implemented as empty function doing nothing
};
